import * as React from 'react';
import * as I18n from 'i18n-js';
import Currency from '@reverbdotcom/commons/dist/currency';
import SanitizedRender from '@reverbdotcom/commons/dist/components/sanitized_render';
import bind from '@reverbdotcom/commons/dist/bind';

export interface Props {
  defaultShopCurrencyCode: string;
  currencies: { code: string; name: string }[];
  currencyErrors: string[];
  shopCurrencyCode: string;
  onCurrencyChange(currency: string): void;
}

export default class ShopCurrencySelect extends React.Component<Props> {
  get showCurrencyChangeWarning() {
    return this.isCurrencySelected &&
      this.props.defaultShopCurrencyCode !== this.props.shopCurrencyCode;
  }

  get hasErrors() {
    return this.props.currencyErrors && this.props.currencyErrors.length > 0;
  }

  displayCurrencyErrors() {
    if (this.hasErrors) {
      return (
        <div className="alert alert-error">
          <ul>{this.errorListItems()}</ul>
        </div>
      );
    }
    return null;
  }

  optionsForSelect() {
    return (
      this.props.currencies.map(currency =>
        (<option
          key={currency.code}
          value={currency.code}
        >
          {currency.name}
        </option>))
    );
  }

  errorListItems() {
    return (
      this.props.currencyErrors.map((error, index) =>
        (
          <li key={index}>
            {error}
          </li>
        ),
      )
    );
  }

  @bind
  onSelected(event) {
    this.props.onCurrencyChange(event.target.value);
  }

  currencyChangeNote() {
    if (this.showCurrencyChangeWarning) {
      return (
        <div className="alert-info ptb-1 plr-1 bd-rounded mtb-1">
          <p className="small mb-0">
            <SanitizedRender
              allowedTags={['strong']}
              html={I18n.t('discovery.payoutMethod.shopCurrency.currencyChange.listingsWillUpdateHtml', {
                strongTagOpen: '<strong>', strongTagClose: '</strong>', oldCurrencyCode: this.props.defaultShopCurrencyCode, newCurrencyCode: this.props.shopCurrencyCode,
              })}
            />
          </p>
          <br />
          <p className="small mb-0">
            <SanitizedRender
              allowedTags={['strong']}
              html={I18n.t('discovery.payoutMethod.shopCurrency.currencyChange.offersWillRemainHtml', {
                strongTagOpen: '<strong>', strongTagClose: '</strong>', oldCurrencyCode: this.props.defaultShopCurrencyCode, newCurrencyCode: this.props.shopCurrencyCode,
              })}
            />
          </p>
        </div>
      );
    }
    return null;
  }

  currencySymbol(currencyCode: string) {
    if (!currencyCode) {
      return '';
    }

    return Currency.get(currencyCode).symbol;
  }

  get sellingFeesDescription() {
    if (this.props.shopCurrencyCode !== 'USD') {
      return I18n.t('discovery.payoutMethod.shopCurrency.sellingFeesDescriptionWithCurrencyConversion', {
        currencySymbol: this.currencySymbol(this.props.shopCurrencyCode),
        currencyCode: this.props.shopCurrencyCode,
      });
    }

    return I18n.t('discovery.payoutMethod.shopCurrency.sellingFeesDescription', {
      currencySymbol: this.currencySymbol(this.props.shopCurrencyCode),
      currencyCode: this.props.shopCurrencyCode,
    });
  }

  get selectedCurrency() {
    return this.props.shopCurrencyCode || this.props.defaultShopCurrencyCode;
  }

  get isCurrencySelected() {
    return !!this.selectedCurrency;
  }

  render() {
    return (
      <div>
        <div className="offset-anchor-wrapper">
          <div id="shop-currency-selector" className="offset-anchor" />
        </div>
        <div className="form-group">
          <div className="form-group__header">
            <label htmlFor="shop_policies_form_shop_currency">
              {I18n.t('discovery.payoutMethod.shopCurrency.currencyLabel')}
            </label>
          </div>
          <div className="form-group__fields">
            {this.displayCurrencyErrors()}
            <div className="width-50 mobile-width-100">
              <div className="styled-dropdown mb-0">
                <select
                  className="required"
                  name="shop_policies_form[shop][currency]"
                  onChange={this.onSelected}
                  required
                  value={this.selectedCurrency}
                >
                  <option value="" disabled>
                    {I18n.t('discovery.payoutMethod.shopCurrency.selectAnOption')}
                  </option>
                  {this.optionsForSelect()}
                </select>
              </div>
            </div>
            {this.currencyChangeNote()}
            {this.isCurrencySelected &&
              <p className="form-group__help-text">
                {this.sellingFeesDescription}
              </p>
            }
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/shop_currency_select.tsx